import React, { FC } from "react"
import L10n from "lib/carrot-l10n"
import { CurrencyString } from "components/views/molecules/CurrencyString"
import { Reimbursement } from "types/reimbursement"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type ReimbursementDeductibleStringProps = {
  reimbursement: Reimbursement
}

type ReimbursementLabelProps = {
  label: string
  amount: number
}

const ReimbursementLabel: FC<ReimbursementLabelProps> = ({ label, amount }) => {
  return (
    <div>
      {label}
      <CurrencyString amount={amount} />
    </div>
  )
}

const EligibleLabel: FC<ReimbursementDeductibleStringProps> = ({ reimbursement }) => (
  <ReimbursementLabel label={l`Eligible for reimbursement: `} amount={reimbursement.eligibleAmount} />
)

const AppliedToDeductibleLabel: FC<ReimbursementDeductibleStringProps> = ({ reimbursement }) => (
  <ReimbursementLabel label={l`Applied to deductible: `} amount={reimbursement.amountAppliedToDeductible} />
)

const AppliedToCostShareLabel: FC<ReimbursementDeductibleStringProps> = ({ reimbursement }) => (
  <ReimbursementLabel label={l`Your contribution: `} amount={reimbursement.membersCostShareContribution} />
)

const ReimbursementsListDeductibleString: FC<ReimbursementDeductibleStringProps> = ({
  reimbursement
}: ReimbursementDeductibleStringProps) => {
  function hasDeductibleContribution() {
    return reimbursement.amountAppliedToDeductible > 0
  }

  function hasCostShareContribution() {
    return reimbursement.membersCostShareContribution > 0
  }

  if (hasDeductibleContribution()) {
    return hasCostShareContribution() ? (
      <>
        <EligibleLabel reimbursement={reimbursement} />
        <AppliedToCostShareLabel reimbursement={reimbursement} />
        <AppliedToDeductibleLabel reimbursement={reimbursement} />
      </>
    ) : (
      <>
        <EligibleLabel reimbursement={reimbursement} />
        <AppliedToDeductibleLabel reimbursement={reimbursement} />
      </>
    )
  } else {
    return hasCostShareContribution() ? (
      <>
        <EligibleLabel reimbursement={reimbursement} />
        <AppliedToCostShareLabel reimbursement={reimbursement} />
      </>
    ) : (
      l``
    )
  }
}

export { ReimbursementsListDeductibleString }
